import React, { useState, useEffect } from 'react'
import useEstimationStyles from './styles'
import { Box, Grid } from '@mui/material'
import CustomTextField from '../../../../components/CustomTextField/CustomTextField'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
import ClearIcon from '@mui/icons-material/Clear'
import dayjs from 'dayjs'
import EstimatedGeneration from '../EstimatedGeneration/EstimatedGeneration'

const Estimation = ({ formik, Edit }) => {
  const classes = useEstimationStyles()
  const [open, setOpen] = React.useState(false)
  const [estimatedGenOpen, setEstimatedGenOpen] = React.useState(false)
  const [estimatedGTIOpen, setEstimatedGTIOpen] = React.useState(false)
  const handleClose = () => {
    setOpen(false)
  }
  const handleestimatedGenClose = () => {
    setEstimatedGenOpen(false)
  }
  const handleestimatedGTIClose = () => {
    setEstimatedGTIOpen(false)
  }
  const Today = dayjs(new Date()).format('MMMM-YYYY')

  const [commissionDate, setCommissionDate] = useState(
    dayjs(new Date()).format('MMMM-YYYY')
  )
  const [commissioninitialDate, setCommissioninitialDate] = useState(
    dayjs(new Date())
  )
  // const [commissionDate, setCommissionDate] = useState(Today);
  const [estimatedData, setEstimatedData] = useState({ [commissionDate]: 100 })

  const editedFields = formik.values.plantDetails?.estimatedYield
  const [editData, setEditData] = useState({
    editedFields,
    // "August-2023": 100,
    // "September-2023": 34,
    // "October-2023": 43
  })

  useEffect(() => {
    const newEstimatedData = {}
    for (const key in editData) {
      newEstimatedData[key] = editData[key]
    }
    setEstimatedData(newEstimatedData)
  }, [editData, commissionDate])

  const handleCommissionDateChange = (value) => {
    const newDate = dayjs(value).format('MMMM-YYYY')
    setCommissionDate(newDate)
  }

  const handleChange = (name, value) => {
    setEstimatedData((prevData) => ({ ...prevData, [name]: parseFloat(value) }))
    formik.setFieldValue(`plantDetails.estimatedYield`, estimatedData)
  }

  const generateMonthOptions = () => {
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]

    const [selectedMonth, selectedYear] = commissionDate.split('-')
    const startIndex = months.indexOf(selectedMonth)
    const startYear = parseInt(selectedYear, 10)

    const monthInputs = []

    for (let i = startIndex; i < startIndex + 12; i++) {
      const monthIndex = i % 12
      const year = startYear + Math.floor(i / 12)
      const month = months[monthIndex]
      const key = `${month}-${year}`
      monthInputs.push(
        <Grid key={key} item xs={12} md={4}>
          <div>
            <CustomTextField
              label={key}
              id="filled-size-small"
              value={estimatedData[key] || ''}
              onChange={(value) => handleChange(key, value.target.value)}
            />
          </div>
        </Grid>
      )
    }

    return monthInputs
  }

  const MinGuranteedupdate = (value) => {
    const MingData = { [CommYear]: Number(value.target.value) }
    // formik.setFieldValue(`plantDetails.minimumGuaranteedOg`, MingData)
    formik.setFieldValue(`plantDetails.minimumGuaranteedValue`, MingData)
    formik.setFieldValue(`plantDetails.minimumGuaranteed`, MingData)
  }
  const InvGuranteedupdate = (value) => {
    const MingData = { [CommYear]: Number(value.target.value) }
    // formik.setFieldValue(`plantDetails.investorGuaranteedOg`, MingData)
    formik.setFieldValue(`plantDetails.investorGuaranteedValue`, MingData)
    formik.setFieldValue(`plantDetails.investorGuaranteed`, MingData)
    // formik.setFieldValue(`plantDetails.minimumGuaranteedOg`, Number(value.target.value))
  }

  const PreviousCommDate = new Date(
    formik?.values?.plantDetails?.commissionDate
  )
  const CommYear = PreviousCommDate.getFullYear()

  return (
    <div className={classes.root}>
      <Box
        sx={{
          '& .MuiTextField-root': { m: 1, width: '100%' },
        }}
        noValidate
        autoComplete="off"
      >
        <Grid container spacing={2} className="mb_20">
          <Grid item xs={12} md={4}>
            <div className=" textfield ">
              <CustomTextField
                label="Degradation Factor"
                id="filled-size-small"
                type="number"
                value={formik.values.plantDetails?.degradationFactor}
                onChange={(value) =>
                  formik.setFieldValue(
                    `plantDetails.degradationFactor`,
                    Number(value.target.value)
                  )
                }
              />
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className=" textfield ">
              <CustomTextField
                label="Minimum Guaranteed Generation"
                id="filled-size-small"
                type="number"
                value={
                  formik.values.plantDetails?.minimumGuaranteedValue?.[CommYear]
                }
                // value={formik.values.plantDetails?.minimumGuaranteedOg?.[CommYear]}
                onChange={(value) => MinGuranteedupdate(value)}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className=" textfield ">
              <CustomTextField
                label="Investor Guaranteed Generation"
                type="number"
                id="filled-size-small"
                value={
                  formik.values.plantDetails?.investorGuaranteedValue?.[
                    CommYear
                  ]
                }
                // value={formik.values.plantDetails?.investorGuaranteedOg?.[CommYear]}
                onChange={(value) => InvGuranteedupdate(value)}
                // onChange={(value) => formik.setFieldValue(`plantDetails.inverterGuaranteedGeneration`, Number(value.target.value))}
              />
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={2} pl={1}>
          <Grid item xs={12} md={4}>
            <div
              // type="submit"
              onClick={() => setOpen(true)}
              className={classes.estimationButton}
            >
              Estimated Yield
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div
              // type="submit"
              className={classes.estimationButton}
              onClick={() => setEstimatedGTIOpen(true)}
            >
              Estimated GTI
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div
              // type="submit"
              className={classes.estimationButton}
              fullWidth
              onClick={() => setEstimatedGenOpen(true)}
            >
              Estimated Generation
            </div>
          </Grid>
        </Grid>

        <Dialog
          className="businessview_dialog"
          open={open}
          onClose={handleClose}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            <div className="align_btw brdr">
              <div className="h_1">Estimated Yield</div>

              <DialogActions>
                <ClearIcon onClick={handleClose} className="pointer" />
              </DialogActions>
            </div>
          </DialogTitle>
          <DialogContent>
            <EstimatedGeneration
              formik={formik}
              Edit={Edit}
              Type="plantDetails.estimatedYield"
              OgType="plantDetails.estimatedYieldValue"
              FormikFields={formik.values.plantDetails?.estimatedYieldValue}
            />

            <DialogActions></DialogActions>
          </DialogContent>
        </Dialog>
        <Dialog
          className="businessview_dialog"
          open={estimatedGTIOpen}
          onClose={handleestimatedGTIClose}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            <div className="align_btw brdr">
              <div className="h_1">Estimated GTI </div>

              <DialogActions>
                <ClearIcon
                  onClick={handleestimatedGTIClose}
                  className="pointer"
                />
              </DialogActions>
            </div>
          </DialogTitle>
          <DialogContent>
            <EstimatedGeneration
              formik={formik}
              Edit={Edit}
              Type="plantDetails.estimatedGTI"
              OgType="plantDetails.estimatedGTIValue"
              FormikFields={formik.values.plantDetails?.estimatedGTIValue}
            />

            <DialogActions></DialogActions>
          </DialogContent>
        </Dialog>
        <Dialog
          className="businessview_dialog"
          open={estimatedGenOpen}
          onClose={handleestimatedGenClose}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            <div className="align_btw brdr">
              <div className="h_1">Estimated Generation </div>

              <DialogActions>
                <ClearIcon
                  onClick={handleestimatedGenClose}
                  className="pointer"
                />
              </DialogActions>
            </div>
          </DialogTitle>
          <DialogContent>
            <EstimatedGeneration
              formik={formik}
              Edit={Edit}
              Type="plantDetails.estimatedGeneration"
              OgType="plantDetails.estimatedGenerationValue"
              FormikFields={
                formik.values.plantDetails?.estimatedGenerationValue
              }
            />
            <DialogActions></DialogActions>
          </DialogContent>
        </Dialog>
      </Box>
    </div>
  )
}

Estimation.propTypes = {}

export default Estimation
